;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin\",\"regex\":\"^/([^/]+)/admin$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/chat\",\"regex\":\"^/([^/]+)/chat$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs\",\"regex\":\"^/([^/]+)/dogs$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id\",\"regex\":\"^/([^/]+)/dogs/([^/]+)$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/dashboard\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/dashboard$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/edit\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/edit$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/forms/medication\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/forms/medication$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/forms/vaccination\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/forms/vaccination$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/forms/vet-visit\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/forms/vet-visit$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/:id/timeline\",\"regex\":\"^/([^/]+)/dogs/([^/]+)/timeline$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dogs/new\",\"regex\":\"^/([^/]+)/dogs/new$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/log\",\"regex\":\"^/([^/]+)/log$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/chat\",\"regex\":\"^/([^/]+)/onboarding/chat$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/country\",\"regex\":\"^/([^/]+)/onboarding/country$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/dog\",\"regex\":\"^/([^/]+)/onboarding/dog$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/welcome\",\"regex\":\"^/([^/]+)/onboarding/welcome$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/reminders\",\"regex\":\"^/([^/]+)/reminders$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/reminders/new\",\"regex\":\"^/([^/]+)/reminders/new$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/review\",\"regex\":\"^/([^/]+)/review$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/upgrade\",\"regex\":\"^/([^/]+)/upgrade$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/activate\",\"regex\":\"^/([^/]+)/activate$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/login\",\"regex\":\"^/([^/]+)/login$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/signup\",\"regex\":\"^/([^/]+)/signup$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/ai-transparency\",\"regex\":\"^/([^/]+)/ai-transparency$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/pricing\",\"regex\":\"^/([^/]+)/pricing$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/privacy\",\"regex\":\"^/([^/]+)/privacy$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/terms\",\"regex\":\"^/([^/]+)/terms$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from '@sentry/nextjs';

/**
 * Sentry Client-side Configuration (Browser runtime)
 *
 * This file replaces sentry.client.config.ts for Next.js 16+ (Turbopack).
 * Next.js automatically loads this file on the client side.
 *
 * Requirements:
 * - EU data residency (de.sentry.io)
 * - PII scrubbing: strip email, IP, auth tokens
 * - Session replay: disabled (privacy-first)
 */

Sentry.init({
  // DSN from env var (set per Vercel environment to route to vetta-dev or vetta-prod)
  // Falls back to vetta-dev DSN for local development where NEXT_PUBLIC_SENTRY_DSN may not be set
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    'https://4e40a9db70507ceb800852aed25327e9@o4510886711918592.ingest.de.sentry.io/4510888680030288',

  // Use VERCEL_ENV (preview/production/development) when available, fall back to NODE_ENV for local dev
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV || 'development',

  release:
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || process.env.VERCEL_GIT_COMMIT_SHA || 'unknown',

  // Performance: 10% in production, 100% in dev
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

  // Session Replay: disabled (privacy-first, GDPR)
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  attachStacktrace: true,

  // GDPR: do NOT send PII by default
  sendDefaultPii: false,

  // PII scrubbing
  beforeSend(event) {
    if (event.exception) {
      event.exception.values?.forEach((ex) => {
        if (ex.value) {
          ex.value = ex.value.replace(/[\w\.-]+@[\w\.-]+\.\w+/g, '[email]');
          ex.value = ex.value.replace(
            /(?:auth|token|key|secret|password)[=:\s]*[^\s]+/gi,
            '[redacted]'
          );
        }
      });
    }

    event.breadcrumbs?.forEach((breadcrumb) => {
      if (breadcrumb.data) {
        if (breadcrumb.data.url) {
          breadcrumb.data.url = breadcrumb.data.url.replace(
            /([?&])(email|token|key|secret|password|auth)=[^&]*/gi,
            '$1$2=[redacted]'
          );
        }
        Object.entries(breadcrumb.data).forEach(([key, value]) => {
          if (typeof value === 'string') {
            breadcrumb.data![key] = value
              .replace(/[\w\.-]+@[\w\.-]+\.\w+/g, '[email]')
              .replace(/(?:auth|token|key|secret|password)[=:\s]*[^\s]+/gi, '[redacted]');
          }
        });
      }
    });

    if (event.user) {
      const { id } = event.user;
      event.user = { id: id || 'unknown' };
    }

    return event;
  },

  ignoreErrors: [
    'NetworkError',
    'TypeError: Failed to fetch',
    'AbortError',
    'top.GLOBALS',
    'chrome-extension://',
    'moz-extension://',
    'firefox-extension://',
    'safari-extension://',
    'csp_report',
    'ResizeObserver loop limit exceeded',
  ],

  initialScope: {
    tags: {
      service: 'vetta',
      tier: 'client',
      runtime: 'browser',
    },
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
